import React, { useEffect, useState, useRef } from 'react';
import TabLayout from '@/pages/MainPage/components/FrameLayout';
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import Page from '@/script/Page';
import EditableTableExt from "@/pages/MainPage/components/EditableTableExt";
import Table from '@/components/Table/Table.jsx';
import usePermission from "@/hooks/usePermission.mjs";
import buildUrl from '@/script/buildUrl.mjs'
import {Button, Col, Form, Modal, Row, Select, Space, Tag} from "antd";
import openWindow from '@/script/openWindow.mjs';
import {SearchOutlined} from "@ant-design/icons";

export const getRev = (row) => {
    const { dataVer, smallVer, verFlag } = row
    const v = dataVer ? dataVer : Number.parseInt(verFlag)
    const _smallVer = dataVer ? null : smallVer
    return _smallVer != null && _smallVer != undefined ? `${v}.${_smallVer}` : String(v)
}

// 地图版本
const Frame = ({ id, code, type, prjId, sVer }) => {
    const http = useHTTP();

    const pageRef = useRef({});
    const tableInstance = {}
    // 表单
    const [form] = Form.useForm();

    // 地图比对类型
    const [compareTypes, setCompareTypes] = useState([
        'BD', 'UI', 'BF', 'SVR', 'MID', 'DB', 'SS', 'AMAI', 'AMAR', 'AO', 'DO', 'OO', 'RULEMRM', 'ISRF',// 固定节点+部件+通用对比
        'SF', // 固定节点+通用对比
        'UC', 'FC', 'BA', 'FA', 'UA', 'DA', 'AA', 'OA', 'RA', 'PA', 'CA', 'LS', 'LSI', 'VR', 'DV', // 通用对比
        'DES', 'CHG', // 其他
        'SA_MAP', 'BF_MAP', 'BIZ_MAP', 'UI_MAP', 'UC_MAP', 'INF_MAP', 'FC_MAP', 'DEP_MAP', 'ANA_MAP', 'ORG_MAP', // 集成地图-通用对比
        'SF_MAP', 'DATA_MAP', // 集成图对比
        'DT', // 数据表对比
        'CDG', // 标准字段组对比
        'CDT', //  定制数据类型对比
        'DTO', // DTO对比
    ]);

    // 数据模型
    const [mapVers, setMapVers] = useState([]);
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState([]);

    const [selectedRows, setSelectedRows] = useState([]); // 选中的对象集合

    // 加载显示
    const [loading, setLoading] = useState(false);

    // 更新权限
    const hasUpt = usePermission([type + '_UPT'], [prjId], []);

    // 组件初始化
    useEffect(() => {
        if(sVer){
            form.setFieldsValue({ sVers: [sVer] });
        }

        setColumns(optColumns)
        doSearch();
        queryBaseLineData(prjId);
    }, [id, code, type, prjId, sVer]);

    const doSearch = async () => {
        try {
            setLoading(true);
            const formField = await form.getFieldsValue();
            const data = await runAsync(
                async () => {
                    return await http.get(`/basmapvers/rls`, {dataId: id, dataType: type, prjId, sVers: formField.sVers});
                }, {
                error: { content: (err) => `查询失败: ${err.message}` },
                loading: { show: false },
                success: { show: false },
            });
            setMapVers(data);

            // 获取模型成品信息
            queryPatternInfos(data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const queryBaseLineData = async (prjId) => {
        try {
            const list = await runAsync(
                async () => {
                    return await http.get(`/prjbaselines`, { prjId});
                }, {
                    error: { content: (err) => `查询失败: ${err.message}` },
                    loading: { show: false },
                    success: { show: false },
                });

            const options = [];
            for (const v of list) {
                options.push({ value: v.sVer, label: '[' + v.sVer + ']' + v.pblName });
            }
            setData(options);
        } catch (err) {
            console.log(err);
        }
    }

    // 获取模型成品信息
    const queryPatternInfos = async (data) => {
        try {
            // 分页
            pageRef.current.pageSize = pageRef.current.pageSize ?? Page.pageSize;
            pageRef.current.currentPage = pageRef.current.currentPage ?? 1;

            // 总数据
            const totalData = tableInstance.refinedRows ?? data;

            // 计算最大页
            const maxPage = Math.ceil(totalData.length / pageRef.current.pageSize);
            // 获取当前页，取最小值
            const currentPage = Math.min(pageRef.current.currentPage, maxPage);
            //console.log("currentPage", currentPage)
            // 获取当前页数据
            const selectedRows = totalData.slice((currentPage - 1) * pageRef.current.pageSize, currentPage * pageRef.current.pageSize);

            if (selectedRows.length == 0) {
                return
            }

            const patternInfos = await runAsync(
                async () => {
                    return await http.get(`/basmapvers/patterninfos`, { pkids: selectedRows.map(it => it.pkid)});
                }, {
                    error: { content: (err) => `查询失败: ${err.message}` },
                    loading: { show: false },
                    success: { show: false },
                });
            if(patternInfos){
                const mapVers = data.map(it => {
                    const patternInfo = patternInfos.find(it2 => it2.pkid === it.pkid);
                    if(patternInfo){
                        const { lastPatternId, prjPatternId, patternRev, patternTitle } = patternInfo
                        return { ...it, lastPatternId, prjPatternId, patternRev, patternTitle };
                    }
                    return { ...it};
                })
                console.log("mapVers", mapVers)
                setMapVers([...mapVers]);
            }
        } catch (err) {
            console.log(err);
        }
    }

    // 保存备注
    const doSave = async (mapVer) => {
        try {
            setLoading(true);

            const data = await runAsync(
                async () => {
                    return await http.put(`/basmapvers/${mapVer.pkid}`, mapVer);
                }, {
                error: { content: (err) => `保存失败: ${err.message}` },
                loading: { show: false },
                success: { show: false },
            });

            //setOptLogs(data);
        } catch (err) {
            console.log(err);
            // 有异常重新加载日志
            doSearch();
        } finally {
            setLoading(false);
        }
    }

    // 查看历史版本
    const ViewVersion = ({ value: { sVer, dataVer, pkid, dataType, prjPatternId, patternRev }, ...props }) => {
        const openVersion = (pkid, prjPatternId, patternRev) => {
            const url = dataType === 'UV' ?
                buildUrl('/FormilyLog', { id: pkid, prjPatternId, patternRev })
                :
                buildUrl('/SoftwareMap', { id: pkid, mode: 'snapshot', prjPatternId, patternRev });
            window.open(url);
        }

        return (<a href="javascript:void(0);" rel="noreferrer" onClick={() => openVersion(pkid, prjPatternId, patternRev)} {...props}>{dataVer}</a>);
    }

    // 对比
    const ViewCompare = ({contentType, leftRev, verId }) => {
        const onClick = async () => {
            setLoading(true);
            const url = buildUrl(
                '/DiffMap',
                {
                    basMapVerId: verId,
                    contentType,
                    tarDpId: id,
                    type: type,
                }
            );

            window.open(url);
            setLoading(false);
        }

        return (
            <a
                href="javascript:void(0);"
                rel="noreferrer"
                /*target="_blank"*/
                title={"比对迭代版"}
                onClick={onClick}
            >
                比对迭代版
            </a>
        )
    }

    // 需求确认单详情
    const linkDes = (desId) => {
        openWindow('/DesDetail', { desId });
    }

    // 模型成品详情
    const linkPattern = (prjPatternId, patternRev, sVer) => {
        openWindow('/PrjPatternDetail', { prjPatternId, patternRev, sVer });
    }

    const optColumns = [
        {
            dataIndex: 'crtTime',
            title: '发布时间',
            width: 180,
            component: <Table.ViewText />,
        },
        {
            dataIndex: 'crtName',
            title: '发布人',
            component: <Table.ViewText />,
            width: 120,
        },
        // {
        //     title: '分支号',
        //     dataIndex: 'sVer',
        //     align: 'center',
        //     width: 80,
        // },
        {
            dataIndex: 'dataVer',
            title: '版本号',
            width: 80,
            align: 'center',
            render: (text, record, index) => {
                return <ViewVersion value={{ dataVer: record.sVer+"."+ (record?.dataVer ?? Number.parseInt(record?.verFlag)), pkid: record?.pkid, dataType: record.dataType, prjPatternId: record.prjPatternId, patternRev: record.patternRev }} />;
            }
        },
        {
            title: '发布号',
            dataIndex: 'smallVer',
            align: 'center',
            width: 80,
            className: 'center',
            render: (text, record) => {
                if(record.patternRev){
                    return <Tag color={'rgb(80, 195, 247)'}>{text}</Tag>;
                }else{
                    return <Tag style={{border:'0'}}>{text}</Tag>;
                }
            }
        },
        {
            title: '所属模型成品',
            dataIndex: 'lastPatternId',
            align: 'center',
            width: 160,
            ellipsis: true,
            render: (text, record) => {
                if(record.lastPatternId && record.patternRev){
                    const title = '【' + record.patternRev + '】' + (record.patternTitle ?? '');
                    return <a href="javascript:void(0);" rel="noreferrer" onClick={() => linkPattern(record.lastPatternId, record.patternRev, record.sVer)} title={title}>{title}</a>
                }
            }
        },
        {
            dataIndex: 'memo',
            title: '备注',
            component: (!hasUpt) && <Table.ViewLongText />,
            editable: hasUpt ? true : false,
            width: 120,
        },
        compareTypes.includes(type) && {
            dataIndex: 'opt',
            title: '操作',
            width: 120,
            align: 'center',
            render: (text, record, index) => {
                return (
                    <ViewCompare
                        contentType={record.dpContentType}
                        leftRev={getRev(record)}
                        verId={record.pkid}
                    />
                )
            }
        }
    ].filter(r => r);


    // 处理table 回调
    const doCallData = (row) => {
        const newData = [...mapVers];
        const index = newData.findIndex((item) => row.pkid === item.pkid);
        const item = newData[index];
        // 异步保存
        doSave({ ...item, ...row });

        newData.splice(index, 1, { ...item, ...row });
        setMapVers(newData);
    }

    const rowSelection = {
        selectedRowKeys: selectedRows.map(({ pkid }) => pkid),
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
    }

    const openCompareHis = async () => {
        if (selectedRows.length != 2) {
            return Modal.info({ title: '提示信息', content: '请选择两条数据' });
        }
        const sortedRows = selectedRows.sort((verA, verB) => {
            if (verA.crtTime < verB.crtTime) {
                return -1; // verA在verB之前
            } else if (verA.crtTime > verB.crtTime) {
                return 1; // verA在verB之后
            } else {
                return 0; // 日期相同
            }
        })

        console.log("leftRev", getRev(sortedRows[0]))

        const url = buildUrl(
            '/DiffMap',
            {
                type,
                basMapVerId: sortedRows[0].pkid,
                tarMapVerId: sortedRows[1].pkid,
            }
        )
        window.open(url);
    }


    let ExtraButtons = [
        <Button type="primary" onClick={openCompareHis}>版本比对</Button>
    ]

    // 分页下标点击回调事件
    const onPage = (current, pageSize) => {
        pageRef.current.currentPage = current;
        pageRef.current.pageSize = pageSize;

        queryPatternInfos(mapVers);
    }

    const doReset = () => {
        form.resetFields();
        form.setFieldsValue({sVers: [sVer] });
        doSearch();
    }

    return (
        <TabLayout>
            <TabLayout.Header title="发布版本">

            </TabLayout.Header>

            {/* 查询条件 */}
            <div style={{padding: '12px 12px 0px', background: '#f0f2f5'}}>
                <div style={{padding: '24px 24px 0px', background: '#fff'}}>
                    <Form form={form} onFinish={() => doSearch()} size={'middle'}>
                        <Row gutter={24}>
                            <Col span={6}>
                                <Form.Item name="sVers" label="分支号">
                                    <Select
                                        allowClear={true}
                                        style={{ width: '300px' }}
                                        size="small"
                                        mode={'multiple'}
                                        showSearch
                                        options={data}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input?.toLowerCase())}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={6} offset={12} style={{textAlign: 'right'}}>
                                <Button onClick={doReset} style={{margin: '0 8px'}}>重置</Button>
                                <Button type="primary" htmlType="submit" icon={<SearchOutlined/>}>查询</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>

            <TabLayout.Content style={{background: '#f0f2f5'}}>
                <div className="smstable">
                    <div className="smstable-body">
                        {/* 按钮区 */}
                        <div className="smstable-body-toolbar">
                            <Space>
                                {compareTypes.includes(type) && ExtraButtons}
                            </Space>
                        </div>

                        {/* 数据区 */}
                        <EditableTableExt
                            doCallData={doCallData} rows={mapVers} columnss={columns}
                            loading={loading}
                            pagination={{...Page.init(mapVers),onChange: onPage}}
                            rowKey={record => record.pkid}
                            rowSelection={compareTypes.includes(type) ? { type: "checkbox", ...rowSelection } : null}
                        />
                    </div>
                </div>
            </TabLayout.Content>
        </TabLayout>
    );
}

export default Frame;
